module.exports = __webpack_public_path__ + "img/white_img.a75c2083.png";